export const downloadTicketsReportProgressModalTexts = {
  HEADER_TITLE: 'download_report',
  FIRST_DESCRIPTION: 'preparing_report_for_download',
  SECOND_DESCRIPTION: 'facing_issues',
  CANCEL_BUTTON_TITLE: 'cancel_this_download',
};
